import { api } from 'roboflex-thalamus-request-handler'

export async function listarLogsProjeto(payload = {}) {
    const response = await api.post('gestao/projeto-logs/listar', payload)
    return response.data
}
